export type VolumePage = {
  src: string
  /** Shown under the page and used as its alt text. */
  caption: string
}

/** Volume 4 — Owning the Room. Pages are shown exactly as exported, in this order. */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/h64ZJr6FBFEDPCn2XYdURp/01-cover.png',
    caption: 'Your new go-to volume on delivery: voice, body, eyes and nerves.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/h4s8MDAsLwfBLQcqn6Wt8t/02-open-stance.png',
    caption: 'Before/after pages your group gets at a glance.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qoRrotVu2RdYMSJFGoUoZZ/03-eye-line-system.png',
    caption: 'Simple systems, like where to look and for how long.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xrxSMc6mjPcpfrWHShaYDL/04-nerve-to-energy.png',
    caption: 'Turn stage fright into energy, with a 3-step routine.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fU2uToGvShjsHVfvQr81Lq/05-field-card.png',
    caption: 'The whole volume on one printable field card.',
  },
]
